import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSuppliers as getSuppliersApi,
  addSupplier as addSupplierApi,
  updateSupplier as updateSupplierApi,
  deleteSupplier as deleteSupplierApi,
} from "../../apiCalls/caller";
import { toast } from "react-toastify";

export const getSuppliers = createAsyncThunk(
  "suppliers/getSuppliers",
  async (data) => {
    try {
      const response = getSuppliersApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addSupplier = createAsyncThunk(
  "suppliers/addSupplier",
  async (supplier) => {
    toast.dismiss();
    try {
      const response = addSupplierApi(supplier);
      const data = await response;

      if (data.success) {
        toast.success("Supplier created Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Supplier creation Failed " + data.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return response;
    } catch (error) {
      toast.error("Supplier creation Failed " + error, {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateSupplier = createAsyncThunk(
  "suppliers/updateSupplier",
  async (supplier) => {
    toast.dismiss();
    try {
      const response = updateSupplierApi(supplier);
      const data = await response;

      if (data.success) {
        toast.success("Supplier updated Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Supplier update Failed " + data.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return data;
    } catch (error) {
      toast.error("Supplier update Failed " + error, {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteSupplier = createAsyncThunk(
  "suppliers/deleteSupplier",
  async (supplier) => {
    toast.dismiss();
    try {
      const response = deleteSupplierApi(supplier);
      const data = await response;

      if (data.success) {
        toast.success("Supplier deleted Successfully", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Supplier deletion Failed " + data.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      return data;
    } catch (error) {
      toast.error("Supplier deletion Failed " + error.message, {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);
